import Vue from 'vue';
import App from './App.vue';
import VueApexCharts from 'vue-apexcharts';
import i18n from './i18n';
// to embed it in iframe, with size set properly
import 'iframe-resizer/js/iframeResizer.contentWindow.min';

Vue.config.productionTip = false;

Vue.use(VueApexCharts);
Vue.component('ApexChart', VueApexCharts);

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#fmh-indikatoren-app');
